import React from 'react';
import { Redirect } from 'react-router-dom';
import paths from '../../_helpers/paths';
import useUser from '../LoginPage/useUser';
import permissions from '../../_helpers/permissions';

export default function HomePage() {
  const user = useUser();
  const hasAccessContingent = user?.permissions?.some(p =>
    [permissions.DDOReportPage, permissions.MIO_EMPLOYEE].includes(p)
  );
  return (
    <Redirect
      to={
        hasAccessContingent ? paths.contingentReportDDOPage : paths.colleaguesReportPage
      }
    />
  );
}
